// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__FFpgk","mark":"Logo_mark__Swedb","wordmark":"Logo_wordmark__doQBx"};